import { Box, Button, Dialog, Grid, TextField, Typography } from "@material-ui/core"
import { useState } from "react"
import { useDispatch } from "react-redux";
import { NuevoMailOferente } from "../../../../actions/compras/OferentesAction";

export const ModalAgregarMail = (props) => {
    const dispatch = useDispatch();
    const [email, setEmail] = useState(null);

    const handleSave = ()=>{
        dispatch(NuevoMailOferente(props.idOferente, email));
        props.close();
    }
    return(
        <Dialog
        fullWidth
        maxWidth={'sm'}
        open={props.open}
        >
            <Grid>
                <Typography variant="h6" style={{padding:'1rem', textAlign:'center'}}>Agregar Mail</Typography>
                <Box p={3}>
                    <Grid>
                        <TextField
                            value={email || ""}
                            margin="normal"
                            label="Email"
                            name="email"
                            autoComplete="off"
                            fullWidth
                            onChange={(event) => { setEmail(event.target.value) }}
                        />
                    </Grid>
                </Box>
                <Grid container style={{padding:25}}>
                    <Grid item xs={12}>
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                        >
                            <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                onClick={props.close}

                            >
                                CANCELAR
                            </Button>

                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    style={{ marginLeft: "0.5rem" }}
                                    onClick={handleSave}
                                >
                                    GUARDAR
                                </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Dialog>
    )
}